import { render } from "./Seasons.vue?vue&type=template&id=c85d226e&scoped=true"
import script from "./Seasons.vue?vue&type=script&lang=js"
export * from "./Seasons.vue?vue&type=script&lang=js"

import "./Seasons.vue?vue&type=style&index=0&id=c85d226e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85d226e"]])

export default __exports__